module.exports = __webpack_public_path__ + "media/images/features/draft/icon-faq-question-e25b321560d11263026b0b64ac6b4a96.svg";